import { createContext } from 'react';

export const AudioContext = createContext({
    muted: false,
    setMuted: () => {}
  });